/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * PepsiCo Geospatial UAV API
 * OpenAPI spec version: 0.1.0
 */
import { useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type {
  GetAllLocationsParams,
  HTTPValidationError,
  LocationResponse,
} from "../model";

const withQueryKey = <T extends object, K>(
  query: T,
  queryKey: K,
): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === "queryKey") continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export type getAllLocationsResponse200 = {
  data: LocationResponse[];
  status: 200;
};

export type getAllLocationsResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type getAllLocationsResponseSuccess = getAllLocationsResponse200 & {
  headers: Headers;
};
export type getAllLocationsResponseError = getAllLocationsResponse422 & {
  headers: Headers;
};

export type getAllLocationsResponse =
  getAllLocationsResponseSuccess | getAllLocationsResponseError;

export const getGetAllLocationsUrl = (params?: GetAllLocationsParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const arrayFormatParameters = ["sector", "region", "country"];

    if (Array.isArray(value) && arrayFormatParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? "null" : String(v));
      });
      return;
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/locations/?${stringifiedParams}`
    : `/api/locations/`;
};

/**
 * @summary Advancement locations with optional locations_geo stub (location_geo_id when present)
 */
export const getAllLocations = async (
  params?: GetAllLocationsParams,
  options?: RequestInit,
): Promise<getAllLocationsResponse> => {
  const res = await fetch(getGetAllLocationsUrl(params), {
    ...options,
    method: "GET",
  });

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: getAllLocationsResponse["data"] = body ? JSON.parse(body) : {};
  return {
    data,
    status: res.status,
    headers: res.headers,
  } as getAllLocationsResponse;
};

export const getGetAllLocationsQueryKey = (params?: GetAllLocationsParams) => {
  return [`/api/locations/`, ...(params ? [params] : [])] as const;
};

export const getGetAllLocationsQueryOptions = <
  TData = Awaited<ReturnType<typeof getAllLocations>>,
  TError = HTTPValidationError,
>(
  params?: GetAllLocationsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAllLocations>>,
        TError,
        TData
      >
    >;
    fetch?: RequestInit;
  },
) => {
  const { query: queryOptions, fetch: fetchOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetAllLocationsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getAllLocations>>> = ({
    signal,
  }) => getAllLocations(params, { signal, ...fetchOptions });

  return {
    queryKey,
    queryFn,
    staleTime: 10000,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getAllLocations>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetAllLocationsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAllLocations>>
>;
export type GetAllLocationsQueryError = HTTPValidationError;

export function useGetAllLocations<
  TData = Awaited<ReturnType<typeof getAllLocations>>,
  TError = HTTPValidationError,
>(
  params: undefined | GetAllLocationsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAllLocations>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllLocations>>,
          TError,
          Awaited<ReturnType<typeof getAllLocations>>
        >,
        "initialData"
      >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetAllLocations<
  TData = Awaited<ReturnType<typeof getAllLocations>>,
  TError = HTTPValidationError,
>(
  params?: GetAllLocationsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAllLocations>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllLocations>>,
          TError,
          Awaited<ReturnType<typeof getAllLocations>>
        >,
        "initialData"
      >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetAllLocations<
  TData = Awaited<ReturnType<typeof getAllLocations>>,
  TError = HTTPValidationError,
>(
  params?: GetAllLocationsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAllLocations>>,
        TError,
        TData
      >
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Advancement locations with optional locations_geo stub (location_geo_id when present)
 */

export function useGetAllLocations<
  TData = Awaited<ReturnType<typeof getAllLocations>>,
  TError = HTTPValidationError,
>(
  params?: GetAllLocationsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAllLocations>>,
        TError,
        TData
      >
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetAllLocationsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export type getLocationByUuidResponse200 = {
  data: LocationResponse;
  status: 200;
};

export type getLocationByUuidResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type getLocationByUuidResponseSuccess = getLocationByUuidResponse200 & {
  headers: Headers;
};
export type getLocationByUuidResponseError = getLocationByUuidResponse422 & {
  headers: Headers;
};

export type getLocationByUuidResponse =
  getLocationByUuidResponseSuccess | getLocationByUuidResponseError;

export const getGetLocationByUuidUrl = (locationUuid: string) => {
  return `/api/locations/${locationUuid}`;
};

/**
 * @summary One advancement location by UUID, with locations_geo stub id when present
 */
export const getLocationByUuid = async (
  locationUuid: string,
  options?: RequestInit,
): Promise<getLocationByUuidResponse> => {
  const res = await fetch(getGetLocationByUuidUrl(locationUuid), {
    ...options,
    method: "GET",
  });

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: getLocationByUuidResponse["data"] = body ? JSON.parse(body) : {};
  return {
    data,
    status: res.status,
    headers: res.headers,
  } as getLocationByUuidResponse;
};

export const getGetLocationByUuidQueryKey = (locationUuid: string) => {
  return [`/api/locations/${locationUuid}`] as const;
};

export const getGetLocationByUuidQueryOptions = <
  TData = Awaited<ReturnType<typeof getLocationByUuid>>,
  TError = HTTPValidationError,
>(
  locationUuid: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getLocationByUuid>>,
        TError,
        TData
      >
    >;
    fetch?: RequestInit;
  },
) => {
  const { query: queryOptions, fetch: fetchOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetLocationByUuidQueryKey(locationUuid);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getLocationByUuid>>
  > = ({ signal }) =>
    getLocationByUuid(locationUuid, { signal, ...fetchOptions });

  return {
    queryKey,
    queryFn,
    enabled: locationUuid !== null && locationUuid !== undefined,
    staleTime: 10000,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getLocationByUuid>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetLocationByUuidQueryResult = NonNullable<
  Awaited<ReturnType<typeof getLocationByUuid>>
>;
export type GetLocationByUuidQueryError = HTTPValidationError;

export function useGetLocationByUuid<
  TData = Awaited<ReturnType<typeof getLocationByUuid>>,
  TError = HTTPValidationError,
>(
  locationUuid: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getLocationByUuid>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLocationByUuid>>,
          TError,
          Awaited<ReturnType<typeof getLocationByUuid>>
        >,
        "initialData"
      >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetLocationByUuid<
  TData = Awaited<ReturnType<typeof getLocationByUuid>>,
  TError = HTTPValidationError,
>(
  locationUuid: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getLocationByUuid>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLocationByUuid>>,
          TError,
          Awaited<ReturnType<typeof getLocationByUuid>>
        >,
        "initialData"
      >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetLocationByUuid<
  TData = Awaited<ReturnType<typeof getLocationByUuid>>,
  TError = HTTPValidationError,
>(
  locationUuid: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getLocationByUuid>>,
        TError,
        TData
      >
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary One advancement location by UUID, with locations_geo stub id when present
 */

export function useGetLocationByUuid<
  TData = Awaited<ReturnType<typeof getLocationByUuid>>,
  TError = HTTPValidationError,
>(
  locationUuid: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getLocationByUuid>>,
        TError,
        TData
      >
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetLocationByUuidQueryOptions(locationUuid, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}
